import { formatDate } from '../../../../../../utils/tableFuncs'
import purchaseReportAccountDetailsColumns from './purchaseReportAccountDetailsColumns'
import type { Row } from '@tanstack/react-table'
import type { PurchaseReportAccountDetails } from '../../../../../../types'
import GenericTable from '../../../../../cars/components/V3/_shared/GenericTable/GenericTable'
import { TableMobileCardContent } from '../../../../../cars/components/V3/_shared/GenericTable/TableMobileCardContent'
import { useSearchParams } from 'react-router-dom'
import { formatCurrency } from '../../../utils/formatCurrency'

type PurchaseReportAccountDetailsProps = {
  data: any
  isLoading?: boolean
}
function PurchaseReportAccountDetailsTable({ data, isLoading }: PurchaseReportAccountDetailsProps) {
  const columns = purchaseReportAccountDetailsColumns()

  return (
    <GenericTable
      className="max-h-[50vh]"
      isLoading={isLoading}
      data={data}
      columns={columns}
      mobileCardContent={(row) => {
        return <MobileCardContent row={row} />
      }}
    />
  )
}

export default PurchaseReportAccountDetailsTable

function MobileCardContent({ row }: { row: Row<PurchaseReportAccountDetails> }) {
  const data = [
    {
      label: 'Dato',
      value: formatDate(row.original.transactionDate) || '',
    },
    {
      label: 'Tidspunkt',
      value: formatDate(row.original.transactionTime) || '',
    },
    {
      label: 'Regnr',
      value: useSearchParams()?.[0]?.get('regNo') || '',
    },
    {
      label: 'Kortnr.',
      value: row.original.referenceNo || '',
    },
    {
      label: 'Stasjon',
      value: row.original.retailStationName || '',
    },
    {
      label: 'Produkt',
      value: row.original.productDescription || '',
    },
    {
      label: 'Faktura inkl. mva',
      value: formatCurrency(row.original.amountincVAT),
    },
  ]
  const header = `Transaksjon - ${formatDate(row.original.transactionDate)}`
  return <TableMobileCardContent header={header} data={data} />
}
